/**
 * The age answer on the Feel reflection (2.6).
 *
 * The person may give an age or a time of life ("7", "about nine", "teenage
 * years") in an optional field. Later phases act on it, so what counts as an
 * answer is decided in ONE place, here, before it is handed on: the field keeps
 * whatever was typed (so Back shows it as it was left), but only a real answer
 * goes to the guide, the session's running order and the stage that compares
 * answers. "I don't know" and its relatives are an honest way of leaving the
 * door shut, and must arrive as no answer at all, not as an age of "I don't know".
 *
 * Done on the client, once, rather than in the guide's instructions, because
 * an instruction to ignore such answers is something a model can get wrong and
 * this is not: nothing is sent, so nothing can be misread.
 */

const NO_AGE_ANSWER = new RegExp(
  [
    "^(i\\s+)?(don['’]?t|do\\s+not|dunno)\\b",       // I don't know / I don't remember / dunno
    "^(i['’]?m\\s+)?(not\\s+sure|unsure)\\b",          // not sure / I'm unsure
    '^no\\s+idea\\b',
    '^idk\\b',
    '^(none|n/?a|nothing|no)\\.?$',
    '^[?.\\s-]+$',                                       // a lone ? or dashes
    '^nie\\s+wiem\\b',                                  // Polish: I don't know
    '^nie\\s+jestem\\s+pewn',                           // Polish: I'm not sure
    '^brak\\b',
  ].join('|'),
  'i',
)

/** The age to hand on: what was typed, trimmed, or '' if it is not an answer. */
export function ageAnswer(typed: string): string {
  const text = typed.trim()
  return text && !NO_AGE_ANSWER.test(text) ? text : ''
}
